import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import NProgress from 'nprogress'

import PlayButton from '../PlayButton';
import TagList from '../TagList';

import Train from '../../services/train.js';
import NumberUtils from '../../services/NumberUtils.js';
import Notification from '../../services/Notification.js'
import Element from '../../services/Element.js'

import '../../../css/Track.css';
import '../../../css/elementPage.css';
import '../../../css/Album.css';

class Album extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  fetchData(artistName, albumName) {   
    NProgress.start();

    Train.fetchAlbum({artist: artistName, album: albumName})
    .then((album) => {
      this.setState({album, artistName, albumName});
      NProgress.done();
    }).catch((e) => {
      NProgress.done();
      Notification.show('Error loading album data', 'error');
    });
  }

  componentDidMount() {
    let artist = decodeURIComponent(this.props.match.params.artist);
    let album = decodeURIComponent(this.props.match.params.album);
    this.fetchData(artist, album);
  }

  componentWillReceiveProps(newProps) {
    let artist = decodeURIComponent(newProps.match.params.artist);
    let album = decodeURIComponent(newProps.match.params.album);
    if (artist !== this.state.artistName || album !== this.state.albumName) {
      this.setState({album: undefined, artistName: undefined, albumName: undefined});
      this.fetchData(artist, album);    
    }
  }

  render() {

    let album = this.state.album;

    if (!album) {
      return <div className="elementPage"></div>;
    }

    let imageStyle = {
      backgroundImage: `url(${album.img})`
    };
    
    let tracks = album.tracks.map(function(track, index){

      return(
        <li id={`track_${index}`} className={`clickable`} key={index}>
          {index + 1}: <Link to={Element.url('track', track)}>{track.track}</Link> <PlayButton type={'track'} element={track}/>
        </li>
        );
    });

    return (
 
      <div className="elementPage">

        <div className="header">

          <div className="profileImage square" style={imageStyle} ></div>

          <div className="content">

            <h1>{this.state.albumName}</h1><PlayButton type={'album'} element={album}/>

            <br/>

            <div className="info">
              <span>by <Link to={`/artists/${encodeURIComponent(this.state.artistName)}`}><b>{this.state.artistName}</b></Link></span>
            </div>

            <br/>

            <div className="stats">
              <span><b>Listeners</b> {NumberUtils.abbreviation(album.stats.listeners)}</span>
              <span><b>Plays</b> {NumberUtils.abbreviation(album.stats.playcount)}</span>
            </div>

            <TagList tags={album.topTags} selector={true}/>

          </div>

        </div>

        <ul className="album">
          {tracks}
        </ul>

      </div>
              
    ); 

  }
}

export default Album;



// WEBPACK FOOTER //
// ./src/js/components/album/Album.jsx